import React, { useState } from "react";
import { useCalendlyEventListener, InlineWidget } from "react-calendly";
import ScheduleCallInfoInput from './ScheduleCallInfoInput'
import ScheduleCallComplete from "./ScheduleCallComplete";
import consumerProfileService from "../../../services/consumerProfile.service";
import useMixPanelEvent from "../../../Utils/MixPanel";

export default function ScheduleCallNoUserForm(props) {

    const mixpanelTrack = useMixPanelEvent();

    const [infoEntryComplete, setInfoEntryComplete] = useState(false);
    const [calendlyComplete, setCalendlyComplete] = useState();
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [submited, setSubmited] = useState(false);
    const [consumerName, setConsumerName] = useState("")
    const [consumerEmail, setConsumerEmail] = useState("");
    const advisor = props.advisor
    const hasCalendly = advisor.calendlyUser && advisor.calendlyUrl.length > 0 ? true : false;

    async function handleInfoInputComplete(data) {
        if (hasCalendly) {
            setInfoEntryComplete(true)
            let meetingInfo = {
                calendlyUser: true,
                advisorName: `${advisor.firstName} ${advisor.lastName}`,
                consumerName: data.fullName,
                consumerEmail: data.email,
            }
            setConsumerName(data.fullName);
            setConsumerEmail(data.email);
            mixpanelTrack('Meeting Requested', '3rd Party Meeting Inital Step', meetingInfo);
        } else {
            setCalendlyComplete(true)
            await createMeetingRequest(data)
        }
    }

    useCalendlyEventListener({
        onEventScheduled: (e) => {
            setCalendlyComplete(true);
            createMeetingRequest(null)
        }
    });

    async function createMeetingRequest(data) {
        //create meeting request with info given
        let myInit = {};
        if (!data) {
            let meetingInfo = {
                calendlyUser: true,
                advisorName: `${advisor.firstName} ${advisor.lastName}`,
                consumerName: consumerName
            }
            mixpanelTrack('Meeting Requested', 'Meeting Info', meetingInfo);
            setSubmitDisabled(true)
            myInit = {
                body: {
                    professionalId: advisor.professionalId,
                    advisorEmail: advisor.email,
                    consumerName: consumerName,
                    consumerEmail: consumerEmail,
                    consumerPhoneNumber: "",
                    meetingFormat: "",
                    hasCalendly: true
                }
            };
        } else {

            let meetingInfo = {
                calendlyUser: hasCalendly,
                advisorName: `${advisor.firstName} ${advisor.lastName}`,
                consumerName: data.fullName,
                consumerEmail: data.email,
            }

            mixpanelTrack('Meeting Requested', 'Meeting Info', meetingInfo);
            setSubmitDisabled(true)
            myInit = {
                body: {
                    professionalId: advisor.professionalId,
                    advisorEmail: advisor.email,
                    consumerName: data.fullName,
                    consumerEmail: data.email,
                    consumerPhoneNumber: data.phone,
                    details: data.meetingDetails,
                    meetingFormat: data.scheduleType,
                    hasCalendly: hasCalendly
                }
            };
        }

        try {
            await consumerProfileService.createMeetingRequest(myInit);
            setSubmited(true);
        } catch (error) {
            console.error(error);
        }
        finally {
            setSubmitDisabled(false)
        }
    }

    return (
        <>
            {!infoEntryComplete && !submited && <ScheduleCallInfoInput advisor={props.advisor} submitDisabled={submitDisabled} handleInfoInputComplete={handleInfoInputComplete} />}
            {infoEntryComplete && hasCalendly && !calendlyComplete && <InlineWidget url={advisor.calendlyUrl} />}
            {infoEntryComplete && calendlyComplete && <ScheduleCallComplete advisorName={advisor.firstName} />}
            {submited && !hasCalendly && <ScheduleCallComplete advisorName={advisor.firstName} />}
        </>

    )
}

